module.exports = __webpack_public_path__ + "img/sv.svdd3c991.svg";